angular.module('webtrader').component('priceHigherLower', {
    bindings: {
        collapsed: '=',
    },
    templateUrl: BASE_URL + 'templates/component.priceHigherLower.html',
    controller: function (Quotes, Account, Trades, OpenListOptions, OpenListMarket, OPTIONS_LIST) {
        this.quotes = Quotes;
        this.account = Account;

        this.inc = (val, add) => (typeof val !== 'number' || isNaN(val)) ? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add));
        this.volume = 1;
        this.expiration = 5;

        this.openTrade = (cmd) => {
            if (cmd == 1 && this.selStatus) {
                return;
            }
            if (cmd == 0 && this.buyStatus) {
                return;
            }

            Trades.order({
                cmd: cmd,
                symbol: Quotes.currentSymbol,
                volume: this.volume,
                expiration: this.expiration,
            })
        };

        Object.defineProperty(this, 'buyStatus', {
            get: () => Trades.orderStatus == 'loading' && 0 == Trades.orderCmd
        });
        Object.defineProperty(this, 'selStatus', {
            get: () => Trades.orderStatus == 'loading' && 1 == Trades.orderCmd
        });


        this.openOptions = (type, cmd) => {

            let dataArray = OPTIONS_LIST[type];

            let result = dataArray.map((val) => {
                return {
                    value: val,
                    text: cmd(val)
                };
            });

            OpenListOptions.open(type, result).then((data) => {
                if (data) {
                    this[type] = data;
                }
            });
        };

        this.openMarketList = ($event) => {
            $event.preventDefault();
            $event.stopPropagation();

            if (OpenListMarket.isOpen) {
                return;
            }

            OpenListMarket.open();
        };

        this.isOpenOptions = (type) => {
            return OpenListOptions.isOpen && OpenListOptions.type == type;
        };

        this.isOpenMarket = () => OpenListMarket.isOpen;

        this.setHover = (type) => Trades.hoverTypeTrade = type;
    }
});


